import assetUrl from 'src/utils/assetUrl'

// Brand marks for the three payment methods that render a pixel-perfect
// SVG instead of a FontAwesome glyph — the empty entries in
// ./paymentMethods' GLYPHS table.
//
// Kept in its own module rather than on the registry so the v6 widget can
// import it without dragging the registry's FontAwesome imports into its
// bundle (v6 is deliberately not a registry consumer — see the comment
// there). Keys are the registry's method names; v6 maps them onto its own
// option vocabulary at the point of use.
const LOGOS = {
  paypal:     assetUrl(RAILS_ASSET_URL('/widgets/donate/paypal.svg')),
  venmo:      assetUrl(RAILS_ASSET_URL('/widgets/donate/venmo.svg')),
  google_pay: assetUrl(RAILS_ASSET_URL('/google_logo.svg')),
}

export default LOGOS
